module.exports = __webpack_public_path__ + "static/hakka-cookbook-logo-a01ddeba787d14aac9b360ef246a88f6.png";